import React, {useState} from 'react';
import {Pressable, View} from 'react-native';
import {makeStyles} from '@rneui/themed';

import theme from '../../../style/theme';
import Text from '../../themed/Text';
import TextInput from '../../themed/TextInput';
import Modal from '../../ui-controls/Modal';

type InputModalProps = {
  element: (props: {onPress: any}) => React.ReactNode;
  openAction: any;
  title: string;
  saveAction: any;
  saveText?: string;
  closeAction: any;
  initialValue?: string;
  placeholder?: string;
  allCaps?: boolean;
  isVisible?: boolean;
};

/**
 * Use this for setting single value fields
 * @param param0
 * @returns
 */
function InputModal({
  element,
  openAction,
  isVisible,
  title,
  saveAction,
  saveText = 'SAVE',
  closeAction,
  initialValue = '',
  placeholder = '',
  allCaps = false,
}: InputModalProps) {
  const styles = useStyles();
  const [value, setValue] = useState(initialValue);
  const capitalisation = allCaps ? 'characters' : 'sentences';
  return (
    <>
      {element({onPress: openAction})}
      <Modal
        title={title}
        isVisible={isVisible ?? false}
        onBackdropPress={closeAction}>
        <View>
          <TextInput
            defaultValue={initialValue}
            onChangeText={val => setValue(val)}
            style={styles.textInput}
            autoCapitalize={capitalisation}
            placeholder={placeholder}
            autoFocus
          />
          <View style={styles.buttonsContainer}>
            <Pressable
              onPress={() => saveAction(value)}
              style={{
                ...styles.okButton,
                ...styles.button,
              }}>
              <Text style={styles.disabledButton.text}>{saveText}</Text>
            </Pressable>
            <Pressable onPress={closeAction} style={styles.button}>
              <Text style={styles.button.text}>CANCEL</Text>
            </Pressable>
          </View>
        </View>
      </Modal>
    </>
  );
}

const useStyles = makeStyles(() => ({
  text: {
    color: theme.colour.text.heading.primary,
  },
  textInput: {
    fontSize: 20,
    fontWeight: '400',
    fontFamily: undefined,
    paddingLeft: 12,
    minHeight: 32,
    borderColor: 'grey',
    borderWidth: 0.5,
    borderRadius: 4,
    color: theme.colour.text.form.textInput.primary,
    marginVertical: 16,
    width: '100%',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  okButton: {
    marginTop: 8,
    marginBottom: 16,
  },
  button: {
    backgroundColor: theme.colour.background.button.primary,
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 4,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600',
    },
  },
  disabledButton: {
    borderColor: 'darkgray',
    backgroundColor: 'lightgrey',
    paddingVertical: 8,
    borderRadius: 4,
    paddingHorizontal: 16,
    alignItems: 'center',
    text: {
      color: 'white',
      fontWeight: '600',
    },
  },
  closedComponent: {
    borderWidth: 0.5,
    borderColor: theme.colour.uiControls.primary,
    borderRadius: 4,
    paddingVertical: 4,
    paddingTop: 4,
    paddingHorizontal: 4,
    text: {
      color: theme.colour.text.form.textInput.primary,
    },
    placeholder: {
      color: theme.colour.text.form.textInput.placeholder,
    },
  },
}));

export default InputModal;
